import React, { Component } from "react";
import { Link } from "react-router-dom";
import IDashboardItem from "../../../models/IDashboardItem";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./MonthlyShipmentsWidget.scss";

type Props = {
    totalMonthlyShipments?: number;
    inEditor?: boolean;
    removeWidget?: () => void;
};

type State = {};

class MonthlyShipmentsWidget extends Component<Props, State> {
    render() {
        return (
            <div className={"MonthlyShipmentsWidget col-12 widget dashboard-widget " + (this.props.inEditor ? "in-editor" : "")}>
                {this.props.inEditor ? (
                    <div className={""}>
                        <OwIconButton iconClass={"fas fa-trash-alt"} iconColorClass={"text-danger"} fn={this.props.removeWidget!} />
                    </div>
                ) : null}
                <OwTitle tag={"h4"} title={"dashboard.monthly_shipments"} />
                <div className="faded-orange number">{this.props.totalMonthlyShipments || 0}</div>
                {this.props.inEditor ? (
                    "View"
                ) : (
                    <Link title={"shipments"} to="/shipments">
                        <OwLabel title={"view"} className={"pointer"} />
                    </Link>
                )}
            </div>
        );
    }
}

export default MonthlyShipmentsWidget;
